import React, { useState, useEffect, Fragment } from "react";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import { GetBusiness } from "../../fetchs";
import "leaflet/dist/leaflet.css";
import "./showmap.css";

const ShowMap = (props) => {
  const [location, setlocation] = useState({
    lat: 0,
    lng: 0,
    zoom: 14,
    addressText: "",
    rows: [],
  });
  const { lat, lng, zoom, addressText, rows } = location;

  useEffect(() => {
    loadlocation(props.match.params.id);

    const L = require("leaflet");

    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
  }, [props.match.params.id]);

  const loadlocation = (id) => {
    GetBusiness(id)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        setlocation({
          rows: responseJson,
          lat: responseJson.latitude,
          lng: responseJson.longitude,
          addressText: responseJson.address,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const position = [52.523642219603055, 52.523642219603055];
  const position = [lat, lng];

  return (
    <Map className="container" center={position} zoom={13}>
      <TileLayer
        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={position}>
        <Popup>` ${addressText} `</Popup>
      </Marker>
    </Map>
  );
};
export default ShowMap;
